export const ringVariants = {
  default: {
    code: 'default',
    displayName: 'Default',
    description: 'Standard ring/gauge chart with percentage labels.',
    overrides: {
      props: {},
      className: null,
      styles: {}
    }
  },
  thin: {
    code: 'thin',
    displayName: 'Thin',
    description: 'Narrow ring with configurable width. Larger center area for the metric label.',
    parameters: [
      {
        key: 'ringWidth',
        type: 'select',
        label: 'Ring Width',
        default: 8,
        options: [
          { value: 4, label: 'Extra Thin' },
          { value: 8, label: 'Thin' },
          { value: 12, label: 'Medium' },
          { value: 16, label: 'Thick' },
          { value: 20, label: 'Extra Thick' }
        ]
      }
    ],
    resolve: (params) => ({
      props: {},
      className: null,
      tableClassName: null,
      styles: {
        ringWidth: params.ringWidth
      }
    })
  }
}
